export default __webpack_public_path__ + "static/media/55_mobile.7e8578f3.jpg";